"use client";

import { X, User } from "lucide-react";
import { generatePresignedUrl } from "../postFileAws";
import { useState, useEffect } from "react";

const ProfileModal = ({ isOpen, onClose, participant, profileImageUrls }) => {
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  useEffect(() => {
    if (participant && participant.profilePhotoS3Uri && !profileImageUrls[participant.pid]) {
      setIsLoadingImage(true);
      generatePresignedUrl(participant.profilePhotoS3Uri)
        .then((url) => {
          setProfileImageUrl(url);
        })
        .catch((error) => {
          console.error("Error loading profile image:", error);
        })
        .finally(() => {
          setIsLoadingImage(false);
        });
    } else if (participant && profileImageUrls[participant.pid]) {
      setProfileImageUrl(profileImageUrls[participant.pid]);
    }
  }, [participant, profileImageUrls]);

  if (!isOpen || !participant) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-sm w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">Profile</h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100 transition-colors">
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        {/* Profile Content */}
        <div className="p-6 text-center">
          {/* Profile Image */}
          <div className="mb-4 flex justify-center">
            {isLoadingImage ? (
              <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              </div>
            ) : profileImageUrl ? (
              <img
                src={profileImageUrl || "/placeholder.svg"}
                alt={participant.pName}
                className="w-24 h-24 rounded-full object-cover border-4 border-gray-100"
              />
            ) : (
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center">
                <User size={40} className="text-white" />
              </div>
            )}
          </div>

          {/* Name */}
          <h3 className="text-xl font-semibold text-gray-800 mb-2">{participant.pName}</h3>

          {/* Additional Info */}
          <div className="text-sm text-gray-500 space-y-1">
            <p>User ID: {participant.pid}</p>
          </div>
        </div>

        {/* Actions */}
        <div className="p-4 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="w-full py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
